import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-admin-ad',
  templateUrl: './admin-ad.component.html',
  styleUrl: './admin-ad.component.scss'
})
export class AdminAdComponent implements OnInit {
   public ads =[]
   
   constructor(private auth: AuthServiceService, private toastr: ToastrService, private localService: LocalServiceService,
     private modalService: NgbModal
    ){

   }
  ngOnInit(): void {
     this.loadAds();
     this.fetchMessageAtTop();
  }
  public imgUrl = environment.ImageUrl;

  private imageFile = null;
  public adPosition = 0;
  public isOnLeft = '1';
  public disappearTime = 3;
  public isAdFirst = false;
  public fileLoc = '';
  public adLink = '';


  public imageFileChange(event){
    this.imageFile  = event.target.files[0];
  }

  public deleteAd(id){
    this.localService.confirmYesNo({
      title: 'Confirm Delete',
      text: 'Are you sure you want to delete the ad?',
      icon: 'warning'
    }).then(
      c =>{
        if(c.isConfirmed){
          this.auth.deleteHomepageAd(id).subscribe({
            next: ()=>{
              this.toastr.success("Deleted!");
              this.loadAds();
            },
            error: (err)=>{
              console.error(err);
              this.toastr.error("Error something went wrong while trying to delete");
      
            }
          })

        }else{
          this.toastr.info("Delete cancelled")

        }

      }
    )

  }
  

  public topSideHomeMessage = ''
  private fetchMessageAtTop(){
    this.auth.getSiteInfo('MESSAGE_AT_TOP').subscribe(
      {
        error: console.error,
        next: (data: any) => this.topSideHomeMessage = data.data.value
      }
    )
  }
  public setTopSideHomeMessage(){
    this.auth.setSiteInfo('MESSAGE_AT_TOP', this.topSideHomeMessage).subscribe({
      next: ()=>{
        this.toastr.success("Successfully set!");
        this.fetchMessageAtTop();
      },
      error: err =>{
        console.error(err);
        this.toastr.error("Something went wrong! try again latteer")
      }
    })
    

  }


  public createAd()
  {
    if(!this.fileLoc){
      this.toastr.error("Image is required!")
      return;
    }
    if(!this.disappearTime){
      this.toastr.error("Invalid disappear time")
      return;
    }
    const fd = new FormData();
    if(this.isAdFirst){
      fd.append('isFirstAd', 'true');
    }
    if(this.isOnLeft == '1'){
      fd.append('isOnLeft', 'true');

    }
    if(this.adLink.trim().includes(' ') || (this.adLink.trim().length && !this.adLink.includes('.'))){
      this.toastr.error("Invalid ad LINK!");
      return;
    }
    fd.append('adLink', this.adLink.trim());
   
   
    fd.append('adImage', this.imageFile);
    fd.append('disappearTime', this.disappearTime.toString());
    this.toastr.info("Creating...")
    

    this.auth.createHomepageAd(
      fd
    ).subscribe({
      next: ()=>{
        this.toastr.success("Created!");
        this.loadAds();
        this.resetInputs();
      },
      error: (err)=>{
        console.error(err);
        this.toastr.error("Error something went wrong while trying to add");
        this.resetInputs();
      }
    })
  }

  public showImagePopup(url){
      
    this.modalService.dismissAll();
    const instance = this.modalService.open(ImageModalComponent,{  size: "sm",
        windowClass: "image-modal",
    });
    instance.componentInstance.imageSrc = environment.ImageUrl +url;

  }
  private resetInputs(){
    this.imageFile = null;
    this.adPosition =0;
    this.isOnLeft = '1';
    this.disappearTime = 3;
    this.fileLoc = ''
    this.isAdFirst = false;
  }

  private loadAds(){
    this.auth.getAllHomepageAds().subscribe({
      next: (data: any)=>{
        this.ads = data.data;
      },
      error: (err)=>{
        console.error(err);
        this.toastr.error("Something went wrong while fetching ads!")
      }

    })
  }
}
